let sliderBanner;
window.addEventListener("DOMContentLoaded", () => {
  sliderBanner = new Swiper(".slider-banner .banner__slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    navigation: {
      prevEl: ".banner__slide-button.prev",
      nextEl: ".banner__slide-button.next",
    },
    pagination: {
      el: ".banner__slide-pagination",
    },
  });
});
